export class AnalyticsProviderApiKeyMissingError extends Error {
  constructor(providerName: string) {
    super(`API key is missing for ${providerName}.`);
    this.name = "AnalyticsProviderApiKeyMissingError";
  }
}

export class AnalyticsProviderInitializationError extends Error {
  constructor(providerName: string, error: Error) {
    super(`${providerName} failed to initialize: \n\n${String(error)}`);
    this.name = "AnalyticsProviderInitializationError";
  }
}
